import React, { memo, useCallback } from 'react';

import { NumberInput } from 'ui-components/components/number-input';

import { areProductPropsEqual } from '../utils';
import styles from './styles.module.less';

/**
 * @param {import('../../../types').ColumnProps} props
 * @returns {React.ReactNode}
 */
const Column = ({ value }) => {
  const { product, updateProduct } = value;

  const onChange = useCallback(
    (newValue) => {
      updateProduct(product.rowKey ?? String(product.productId), 'quantity', newValue);
    },
    [product.rowKey, product.productId, updateProduct],
  );

  return (
    <NumberInput
      className={styles['quantity-input']}
      min={1}
      onChange={onChange}
      testId={`quantity-${product.productId}`}
      value={product.quantity}
    />
  );
};

export const QuantityColumn = memo(Column, areProductPropsEqual('quantity'));
